import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'forgentic', {
    // ** Confirm dialog defaults
    confirmOk: 'OK',
    confirmCancel: 'Cancel',

    // ** Home page — kick start card
    homeKickStartTitle: 'Kick start your project 🚀',
    homeKickStartBody1: 'All the best for your new project.',
    homeKickStartBody2:
      'Please make sure to read our Template Documentation to understand where to go from here and how to use our template.',

    // ** Home page — ACL and JWT card
    homeAclJwtTitle: 'ACL and JWT 🔒',
    homeAclJwtBody1:
      'Access Control (ACL) and Authentication (JWT) are the two main security features of our template and are implemented in the starter-kit as well.',
    homeAclJwtBody2:
      'Please read our Authentication and ACL Documentations to get more out of them.',

    // ** Public env status page
    publicEnvStatusTitle: 'Public env status',
    publicEnvStatusDescriptionDocker:
      'Compares values baked into the client bundle at Docker build time with server runtime env. Keys set only at runtime do not reach browser code — rebuild the GHCR image after updating <0>FORGENTIC_NEXT_PUBLIC_ENV</0>.',
    publicEnvStatusDescriptionLocal:
      'Compares values in the Next.js client bundle with the server runtime. After changing any <0>NEXT_PUBLIC_*</0> key, update <1>apps/forgentic/.env</1> and restart the dev server.',
    publicEnvStatusDivergenceWarning_one:
      '{{count}} key diverge between client bundle and server runtime (see Match column).',
    publicEnvStatusDivergenceWarning_other:
      '{{count}} keys diverge between client bundle and server runtime (see Match column).',
    publicEnvStatusAllMatch: 'Client bundle and server runtime agree for all tracked keys.',
    publicEnvStatusColumnKey: 'Key',
    publicEnvStatusColumnClient: 'Client (bundle)',
    publicEnvStatusColumnServer: 'Server (runtime)',
    publicEnvStatusColumnMatch: 'Match',
    publicEnvStatusColumnBaked: 'Baked at build',
    publicEnvStatusBakedYes: 'yes',
    publicEnvStatusBakedNo: 'no',
  });
}
